import React, {useState, useEffect} from "react";
import {Modal, Card, Typography, List, Badge} from "antd";
import {Table, Button, Spin, message} from "antd";
import {TrophyOutlined, CheckCircleOutlined, ReadOutlined, ClockCircleOutlined} from "@ant-design/icons";

import Layout from "../Layout";
// import "./StudentReport.css";


const {Title, Text} = Typography;

function StudentReport() {
    const [students, setStudents] = useState([]);
    const [loading, setLoading] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [selectedStudent, setSelectedStudent] = useState(null);
    const [studentPerformance, setStudentPerformance] = useState(null);
    const [activities, setActivities] = useState([]);
    const [progressReport, setProgressReport] = useState([]);
    const [studyPlan, setStudyPlan] = useState([]);

    const accessToken = localStorage.getItem("accessToken");

    useEffect(() => {
        fetchStudents();
    }, []);

    // Fetch all users, but filter only students
    const fetchStudents = async () => {
        setLoading(true);
        try {
            const response = await fetch("https://api.edumonics.in/admin/get-users", {
                method: "GET",
                headers: {Authorization: `Bearer ${accessToken}`},
            });
            if (response.ok) {
                const users = await response.json();
                const studentsList = users.filter(user => user.role === "student");
                setStudents(studentsList);
            } else {
                message.error("Failed to fetch users");
            }
        } catch (error) {
            console.error("Error fetching users:", error);
        } finally {
            setLoading(false);
        }
    };

    // Fetch all reports when opening modal
    const fetchStudentReport = async (student) => {
        setLoading(true);
        setSelectedStudent(student);
        setModalVisible(true);

        try {
            const [performanceRes, activitiesRes, progressRes, studyPlanRes] = await Promise.all([
                fetch(`https://api.edumonics.in/admin/student-performance/${student.id}`, {headers: {Authorization: `Bearer ${accessToken}`}}),
                fetch(`https://api.edumonics.in/admin/student-activities/${student.id}`, {headers: {Authorization: `Bearer ${accessToken}`}}),
                fetch(`https://api.edumonics.in/admin/student-progress-report/${student.id}`, {headers: {Authorization: `Bearer ${accessToken}`}}),
                fetch(`https://api.edumonics.in/admin/student-study-plan/${student.id}`, {headers: {Authorization: `Bearer ${accessToken}`}}),
            ]);

            const performance = performanceRes.ok ? await performanceRes.json() : null;
            const activitiesData = activitiesRes.ok ? await activitiesRes.json() : [];
            const progressData = progressRes.ok ? await progressRes.json() : [];
            const studyPlanData = studyPlanRes.ok ? await studyPlanRes.json() : [];

            setStudentPerformance(performance);
            setActivities(activitiesData);
            setProgressReport(progressData);
            setStudyPlan(studyPlanData);
        } catch (error) {
            console.error("Error fetching student reports:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Layout pageTitle="Student Reports">
            <div className="container mx-auto px-6 py-12">
                <Title style={{fontFamily: "Gotham, sans-serif"}} level={2} className="text-center">Student Reports</Title>
                <Table
                    dataSource={students}
                    columns={[
                        {title: "Name", dataIndex: "name", key: "name"},
                        {title: "Email", dataIndex: "email", key: "email"},
                        {title: "Role", dataIndex: "role", key: "role"},
                        {
                            title: "Actions",
                            render: (student) => (
                                <Button type="primary" style={{background: "#FAD049", color:"black", fontFamily: "Gotham, sans-serif",}} onClick={() => fetchStudentReport(student)}>
                                    View Report
                                </Button>
                            ),
                        },
                    ]}
                    rowKey="id"
                    loading={loading}
                />
            </div>

            {/*/!* Student Report Modal *!/*/}
            {/*<Modal*/}
            {/*    title={`${selectedStudent?.name}'s Performance Report`}*/}
            {/*    visible={modalVisible}*/}
            {/*    onCancel={() => setModalVisible(false)}*/}
            {/*    footer={null}*/}
            {/*    width={800}*/}
            {/*    zIndex={1000}*/}
            {/*>*/}
            {/*    {loading ? (*/}
            {/*        <Spin size="large"/>*/}
            {/*    ) : studentPerformance ? (*/}
            {/*        <Card>*/}
            {/*            <Title level={4}>Performance</Title>*/}
            {/*            <Text>Email: {studentPerformance.email}</Text>*/}
            {/*            <ul>*/}
            {/*                <li>Total XP: {studentPerformance.total_xp}</li>*/}
            {/*                <li>Quizzes Attempted: {studentPerformance.quizzes_attempted}</li>*/}
            {/*                <li>Average Quiz Score: {studentPerformance.average_quiz_score}%</li>*/}
            {/*                <li>Total Lectures Watched: {studentPerformance.total_lectures_watched}</li>*/}
            {/*                <li>Ranking: #{studentPerformance.ranking}</li>*/}
            {/*                <li>Performance Trend: {studentPerformance.performance_trend}</li>*/}
            {/*            </ul>*/}

            {/*            <Title level={4}>Activities</Title>*/}
            {/*            <ul>{activities.map((a, i) => <li*/}
            {/*                key={i}>{a.activity_type} - {new Date(a.timestamp).toLocaleString()}</li>)}</ul>*/}

            {/*            <Title level={4}>Progress Report</Title>*/}
            {/*            <ul>{progressReport.map((p, i) => <li key={i}>{p.course_name}: {p.completion_rate}%*/}
            {/*                completed</li>)}</ul>*/}

            {/*            <Title level={4}>Study Plan</Title>*/}
            {/*            <ul>{studyPlan.map((s, i) => <li key={i}>{s.topic_name} - {s.reason}</li>)}</ul>*/}
            {/*        </Card>*/}
            {/*    ) : (*/}
            {/*        <Text>No data available</Text>*/}
            {/*    )}*/}
            {/*</Modal>*/}

            <Modal
                title={<Title level={3} style={{marginBottom: 0,fontFamily: "Gotham, sans-serif",}}>{selectedStudent?.name}'s Performance Report</Title>}
                visible={modalVisible}
                onCancel={() => setModalVisible(false)}
                footer={null}
                width={900}
                centered
                style={{borderRadius: "10px", overflow: "hidden",fontFamily: "Gotham, sans-serif",}}
            >
                {loading ? (
                    <Spin size="large"/>
                ) : studentPerformance ? (
                    <div style={{padding: "20px",fontFamily: "Gotham, sans-serif",}}>

                        {/* Performance Summary */}
                        <Card title="Performance Summary" bordered={false} style={{marginBottom: "20px",fontFamily: "Gotham, sans-serif",}}>
                            <List>
                                <List.Item>
                                    <Text><b>Email:</b> {studentPerformance.email}</Text>
                                </List.Item>
                                <List.Item>
                                    <Text><b>Total XP:</b> {studentPerformance.total_xp}</Text>
                                </List.Item>
                                <List.Item>
                                    <Text><b>Quizzes Attempted:</b> {studentPerformance.quizzes_attempted}</Text>
                                </List.Item>
                                <List.Item>
                                    <Text><b>Average Quiz Score:</b> {studentPerformance.average_quiz_score}%</Text>
                                </List.Item>
                                <List.Item>
                                    <Text><b>Total Lectures Watched:</b> {studentPerformance.total_lectures_watched}
                                    </Text>
                                </List.Item>
                                {/*<List.Item>*/}
                                {/*    <Badge.Ribbon text={`Ranking #${studentPerformance.ranking}`} color="blue">*/}
                                {/*        <TrophyOutlined style={{fontSize: "20px", color: "#faad14"}}/>*/}
                                {/*    </Badge.Ribbon>*/}
                                {/*</List.Item>*/}
                                {/*<List.Item>*/}
                                {/*    <Text><b>Performance Trend:</b> {studentPerformance.performance_trend}</Text>*/}
                                {/*</List.Item>*/}
                            </List>
                        </Card>

                        {/* Activities */}
                        <Card title="Recent Activities" bordered={false} style={{marginBottom: "20px",fontFamily: "Gotham, sans-serif",}}>
                            <List
                                dataSource={activities.slice(0, 5)}
                                renderItem={(activity) => (
                                    <List.Item>
                                        <ClockCircleOutlined style={{marginRight: "10px", color: "#1890ff",fontFamily: "Gotham, sans-serif",}}/>
                                        {activity.activity_type} - <Text
                                        type="secondary">{new Date(activity.timestamp).toLocaleString()}</Text>
                                    </List.Item>
                                )}
                            />
                        </Card>

                        {/* Progress Report */}
                        <Card title="Course Progress" bordered={false} style={{marginBottom: "20px",fontFamily: "Gotham, sans-serif",}}>
                            <List
                                dataSource={progressReport}
                                renderItem={(progress) => (
                                    <List.Item>
                                        <ReadOutlined style={{marginRight: "10px", color: "#52c41a",fontFamily: "Gotham, sans-serif",}}/>
                                        <Text><b>{progress.course_name}</b>: {progress.completion_rate.toFixed(2)}%
                                            completed</Text>
                                    </List.Item>
                                )}
                            />
                        </Card>

                        {/* Study Plan */}
                        <Card title="Recommended Study Plan" bordered={false} style={{marginBottom: "20px",fontFamily: "Gotham, sans-serif",}}>
                            {studyPlan.length > 0 ? (
                                <List
                                    dataSource={studyPlan}
                                    renderItem={(plan) => (
                                        <List.Item>
                                            <CheckCircleOutlined style={{marginRight: "10px", color: "#fa541c",fontFamily: "Gotham, sans-serif",}}/>
                                            <Text><b>{plan.topic_name}</b> - {plan.reason}</Text>
                                        </List.Item>
                                    )}
                                />
                            ) : (
                                <Text>No plan Created Yet</Text>
                            )}
                        </Card>

                    </div>
                ) : (
                    <Text>No data available</Text>
                )}
            </Modal>
        </Layout>
    );
}

export default StudentReport;
